import instance from "../api";

export const getCustomerGroups = async () => {
  const response = await instance.get<any>("/DeviceOverview/customers");
  return response.data;
};
